import $ from "../wangeditor/js/util/dom-core.js";
import api from "../api/index.js";
import "aplayer/dist/APlayer.min.css";

export default {
  methods: {
    onMp3Start({ file }) {
      let template = `
     <div contenteditable="false" data-mp3-id="${
       file.id
     }" class="editor-mp3-holder editor-mp3-uploading" id="editor-mp3-${
        file.id
      }" data-progress="0%"></div>
     <p><br></p>
     `;
      this.editor.cmd.do("insertHtml", "<p><br></p>");
      this.editor.cmd.do("insertHtml", template);
      this.editor.cmd.do("insertHtml", "<p><br></p>");
    },
    onMp3Success({ file }) {
      import("aplayer").then(module => {
        const Aplayer = module.default;
        this.player[file.id] = new Aplayer({
          container: document.getElementById(`editor-mp3-${file.id}`),
          audio: [
            {
              name: file.name.replace(".mp3", ""),
              artist: "...",
              url: file.url,
              theme: "#08D7B8"
              // cover: 'cover.jpg'
            }
          ]
        });
        this.getId3(file.id, file.url);
      });

      $(`#editor-mp3-${file.id}`).removeClass("editor-mp3-uploading");
    },
    onMp3Progress({ file }) {
      $(`#editor-mp3-${file.id}`).attr(
        "data-progress",
        Math.floor(file.percentage) + "%"
      );
    },
    onMp3Change({ file }) {},
    getId3(id, url) {
      api.getFileInfoById(id).then(res => {
        if (!res.data.id3) {
          setTimeout(() => {
            this.getId3(id);
          }, 2000);
        } else if (res.data.id3 && res.data.id3.title) {
          let player = this.player[id];
          let id3 = res.data.id3;
          player.container.querySelector(".aplayer-title").textContent =
            id3.title;
          player.container.querySelector(".aplayer-author").textContent =
            id3.artist;
          player.container.querySelector(".aplayer-pic").style.backgroundImage =
            "url(data:image/jpeg;base64," + id3.cover + ")";
        }
      });
    }
  }
};
